'use strict';

angular.module('adminModule')

.config(function ($stateProvider)
{
    $stateProvider
    .state('admin', {
        abstract: true,
        templateUrl: 'navbar/navbar.html',
        controller: 'NavbarController',
        onEnter: function (Auth) {
            Auth.allowedAccess();
        },
        resolve: {
            basket: ['BasketService', 'Auth', (BasketService, Auth) =>  {
                if (Auth.isLoggedIn()) {
                    BasketService.init()
                }
            }]
        }
    });
});
